<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form" style="overflow: visible;">
        <box-form
          @submit="submit"
          :init-box="{ products: [], barcode: '' }"
          :val-errors="valErrors"
          submit-text="Erstellen"
        />
      </card>
    </div>
  </div>
</template>

<script>
import BoxForm from './box-form'

export default {
  components: { BoxForm },
  data () {
    return {
      valErrors: []
    }
  },
  methods: {
    async submit (box) {
      await this.initCsrf()

      this.valErrors = []

      const reqData = {
        name: box.name,
        barcode: box.barcode
      }

      reqData.products = box.products.map(product => {
        return {
          product_id: product.product.id,
          quantity: product.quantity
        }
      })

      this.$http.post('boxes', reqData).then(({ data }) => {
        this.$notify({
          message: 'Box erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push('/boxes')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  }
}
</script>

<style>
</style>
